export default __webpack_public_path__ + "3c0e9a971a51e604ddb49cdb6ac0de82.ogg";